import type { CommentablePersonProfile, SSOIdPConfig, UserProfile } from 'js/src/client';
import { ImmutableFromJS, type ImmutableMap, type ValueOf } from 'js/src/libs/consts';

export type SSOIdPConfigKey = keyof SSOIdPConfig;
export type SSOIdPConfigValue = ValueOf<Pick<SSOIdPConfig, SSOIdPConfigKey>>;

export enum ACCOUNT_ACTIONS {
    // workspaces
    STORE_WORKSPACES = 'STORE_WORKSPACES',
    UPDATE_WORKSPACE = 'UPDATE_WORKSPACE',
    // workspace members
    STORE_WORKSPACE_MEMBERS = 'STORE_WORKSPACE_MEMBERS',
    // team members
    STORE_TEAM_MEMBERS = 'STORE_TEAM_MEMBERS',
    UPDATE_TEAM_MEMBER = 'UPDATE_TEAM_MEMBER',
    // user profile
    STORE_USER_PROFILE = 'STORE_USER_PROFILE',
    // projects
    STORE_PROJECTS = 'STORE_PROJECTS',
    SET_PROJECTS_LOADING_INDICATOR = 'SET_PROJECTS_LOADING_INDICATOR',
    DELETE_PROJECT = 'DELETE_PROJECT',
    // team settings
    STORE_TEAM_SETTINGS = 'STORE_TEAM_SETTINGS',
    UPDATE_MAX_TEAM_SIZE = 'UPDATE_MAX_TEAM_SIZE',
    // invitations
    SET_INVITATIONS_LOADING = 'SET_INVITATIONS_LOADING',
    STORE_INVITATIONS = 'STORE_INVITATIONS',
    DELETE_INVITATION = 'DELETE_INVITATION',
    CREATE_INVITATIONS = 'CREATE_INVITATIONS',
}

export const DamAuthPopupBroadcastChannelName = 'dam-auth-popup-channel';
export enum DamBroadcastMessageType {
    REFRESH = 'refresh',
}
export type DamBroadcaseMessage = {
    type: DamBroadcastMessageType;
    data: null;
};

export function isDamBroadcaseMessage(msg: unknown): msg is DamBroadcaseMessage {
    return (
        typeof msg === 'object' &&
        msg !== null &&
        'type' in msg &&
        typeof msg.type === 'string' &&
        Object.values(DamBroadcastMessageType).includes(msg.type as DamBroadcastMessageType)
    );
}

export type SocialCompletePayload = {
    one_time_password?: string;
    partial_token: string;
    recovery_codes_shown?: boolean;
    is_signup?: string;
    continue_with_signup?: string;
};

export function convertUserProfileToCommentablePersonProfile(
    userProfile: ImmutableMap<UserProfile>,
): ImmutableMap<CommentablePersonProfile> {
    return ImmutableFromJS<CommentablePersonProfile>({
        id: userProfile.get('id'),
        first_name: userProfile.get('first_name'),
        last_name: userProfile.get('last_name'),
        email: userProfile.get('email'),
    });
}
